interface RealimentacionProps {
  currentQuestion: number;
}

export const Realimentacion: React.FC<RealimentacionProps> = ({
  currentQuestion,
}) => {
  const renderContent = () => {
    switch (currentQuestion) {
      case 0:
        return (
          <div>
            <h3>Respuesta:</h3>
            <p>
              Aunque es bastante común confundirlos porque ambos permiten
              disponer de un dinero y devolverlos cuotas, préstamos y créditos
              son dos formas de financiación diferentes.
            </p>
          </div>
        );
      case 1:
        return (
          <div>
            <h3>Respuesta:</h3>
            <p>
              Conocer los intereses corrientes te permite entender el costo real
              de tu préstamo, planificar tus pagos y evitar el
              sobreendeudamiento.
            </p>
          </div>
        );
      case 2:
        return (
          <div>
            <h3>Respuesta:</h3>
            <p>
              Estar al tanto de la cuota de manejo de tu crédito te ayuda a
              gestionar mejor tus gastos y a evitar cargos innecesarios.
            </p>
          </div>
        );
      case 3:
        return (
          <div>
            <h3>Respuesta:</h3>
            <p>
              Negociar una reducción de intereses en tu deuda puede disminuir
              tus pagos mensuales y ayudarte a saldarla más rápido.
            </p>
          </div>
        );
      case 4:
        return (
          <div>
            <h3>Respuesta:</h3>
            <p>
              Conocer los intereses de mora es crucial para evitar cargos
              adicionales por pagos atrasados, lo que te ayudará a mantener tu
              deuda bajo control y mejorar tu historial crediticio.
            </p>
          </div>
        );
      case 5:
        return (
          <div>
            <h3>Respuesta:</h3>
            <p>
              Consultar regularmente el estado de cuenta de tu crédito te
              permite monitorear tus pagos, verificar saldos y detectar
              cualquier error a tiempo.
            </p>
          </div>
        );
      default:
        return <p>sigue intentando</p>;
    }
  };

  return <>{renderContent()}</>;
};
